import {
  makeGIFLoaderComponent,
  makeGLTFLoaderComponent,
  makeImageComponent,
  makePolygonComponent,
  makeShadowComponent,
  makeUPNGLoaderComponent,
  makeVideoButton,
  makeVideoRenderer,
} from 'src/sdk-components';
import { makeControllerButton } from 'src/sdk-components/ControllerButtonComponent';

export enum SceneInitEventsTypes {
  Object = 'object',
  Video = 'video',
  Image = 'image',
  HTML = 'html',
  Avatar = 'avatar',
  Polygon = 'polygon',
  OrientedBox = 'orientedBox',
  Shadow = 'shadow',
  TransformControls = 'controls',
  Loader = 'loader',
  Controller = 'controller',
  Patch = 'patch',
  Barrier = 'barrier',
  CustomSweep = 'customSweep',
  PathLine = 'pathLine',
  Icon = 'icon',
  Trigger = 'trigger',
  Teleport = 'teleport',
  PathPoint = 'pathPoint',
}

export enum NodeEventsTypes {
  OBJECT_HOVER = 'node_hover',
  OBJECT_CLICK = 'node_click',
  IMAGE_HOVER = 'image_hover',
  IMAGE_CLICK = 'image_click',
  HTML_HOVER = 'image_hover',
  HTML_CLICK = 'image_click',
  VIDEO_HOVER = 'video_hover',
  VIDEO_CLICK = 'video_click',
  POLYGON_HOVER = 'polygon_hover',
  POLYGON_CLICK = 'polygon_click',
  POLYGON_EVENTS = 'polygon_events',
  VIDEO_BUTTON_HOVER = 'video_button_hover',
  VIDEO_BUTTON_CLICK = 'video_button_click',
  UNMUTE_AFTER_START = 'handle_video_unmute_after_start',
  AVATAR_BUTTON_HOVER = 'avatar_button_hover',
  AVATAR_BUTTON_CLICK = 'avatar_button_click',
  TRANSFORM_CONTROL_CHANGED = 'changed_transform_controls',
  HANDLE_MODEL_INTERSECTION = 'handle_model_intersection',
  CONTROLLER_MODEL_CLICK = 'controller_model_click',
  TELEPORT_CLICK = 'teleport_click',
  TELEPORT_HOVER = 'teleport_hover',
  NAVIGATION_PATH_RENDER_START = 'path_create_start',
  NAVIGATION_PATH_RENDER_COMPLETE = 'path_create_complete',
  NAVIGATION_PATH_RENDER_FAIL = 'path_create_fail',
  NAVIGATION_PATH_RESET = 'path_reset',
  NAVIGATION_START = 'navigation_start',
  NAVIGATION_COMPLETE = 'navigation_complete',
  NAVIGATION_FAIL = 'navigation_fail',
  NAVIGATION_TELEPORT_RESUME_AUTOMOVE = 'teleport_resume_automove',
}

export enum SDKComponentsTypes {
  UPNGLoader = 'mp.UPNGLoaderComponent',
  Image = 'mp.imageComponent',
  GIFLoader = 'mp.GIFLoaderComponent',
  Shadow = 'mp.shadowComponent',
  Polygon = 'treedis.polygonComponent',
  VideoRenderer = 'treedis.videoRenderer',
  VideoButton = 'treedis.videoButton',
  ControllerButton = 'treedis.controllerButton',
  GltfLoader = 'mp.gltfLoaderComponent',
  OrientedBox = 'treedis.orientedBoxComponent',
}

export const sdkComponents: Array<{
  type: SDKComponentsTypes;
  component: any;
}> = [
  {
    type: SDKComponentsTypes.UPNGLoader,
    component: makeUPNGLoaderComponent,
  },
  {
    type: SDKComponentsTypes.Image,
    component: makeImageComponent,
  },
  {
    type: SDKComponentsTypes.GIFLoader,
    component: makeGIFLoaderComponent,
  },
  {
    type: SDKComponentsTypes.Shadow,
    component: makeShadowComponent,
  },
  {
    type: SDKComponentsTypes.Polygon,
    component: makePolygonComponent,
  },
  {
    type: SDKComponentsTypes.VideoRenderer,
    component: makeVideoRenderer,
  },
  {
    type: SDKComponentsTypes.VideoButton,
    component: makeVideoButton,
  },
  {
    type: SDKComponentsTypes.ControllerButton,
    component: makeControllerButton,
  },
  {
    type: SDKComponentsTypes.GltfLoader,
    component: makeGLTFLoaderComponent,
  },
];
